export enum CommitmentType {
    MANDATORY = 'MANDATORY',
    BEST_EFFORT = 'BEST_EFFORT'
}

export const commitmentTypeDisplay = {
    [CommitmentType.MANDATORY]: 'Mandatory',
    [CommitmentType.BEST_EFFORT]: 'Best Efforts'
};
